import React from 'react'
import Cookies from "js-cookie";
import { CloseIcon } from "~/assets/svg";
import { getLocalizedVal } from '~/tools/localization/helpers'
import './style.scss'

class CookieConsent extends React.Component {
  constructor(){
    super()
    this.state = {
      cc: 1
    }
    this.addCookie = this.addCookie.bind(this)
  }

  componentDidMount(){
    this.setState({ cc: parseInt(Cookies.get("cc"), 10) });
  }

  render() {
    if (this.state.cc === 1) 
      return <div/>
     
    return (
      <div 
        className="cookie-consent" 
        tabIndex="1" 
        role="dialog" 
        aria-describedby="cookie-consent-desc" 
        aria-label="cookieconsent"
      >
        <div id="cookie-consent-desc" className="desc">{getLocalizedVal(window.settings, 'genericMessages', 'cookiesDisclaimer') || 'This website uses cookies to ensure you get the best experience on our website. '}
           <a target="_blank" tabIndex="1" href="/privacy-policy">{getLocalizedVal(window.settings,'genericMessages','learnMore') || 'Learn More'}</a>
        </div>
        <div 
          aria-label="Accept cookie consent" 
          tabIndex="1" 
          className="close-button" 
          onKeyPress={this.addCookie} 
          onClick={this.addCookie}
        > 
          <CloseIcon/> 
        </div>
      </div>
    )
  }

  addCookie(){
    Cookies.set('cc', 1, { expires: 365 })
    this.setState({
      cc : 1
    })
  }
}

export default CookieConsent;
